import { createContext, type PropsWithChildren, useContext, useState } from 'react'

import { type GetBrokersRequiredPaymentsAutopayStatesItem } from 'utils/web_api.schemas'

import { getRequiredPaymentsDefaultQueryParams } from './preconfiguredQueryParams'
import { type RequirePaymentsQueryParameters } from './types'

type RequiredPaymentsContextType = {
  automatedCarriers: string[]
  autopayStates: GetBrokersRequiredPaymentsAutopayStatesItem[]
  queryParams: RequirePaymentsQueryParameters
  setQueryParams: (params: RequirePaymentsQueryParameters) => void
}

const RequiredPaymentsContext = createContext<RequiredPaymentsContextType | undefined>(undefined)

export function useRequiredPaymentsContext () {
  const context = useContext(RequiredPaymentsContext)
  if (!context) {
    throw new Error('useRequiredPaymentsContext must be used within RequiredPaymentsProvider')
  }
  return context
}

type RequiredPaymentsProviderProps = PropsWithChildren<{
  automatedCarriers: string[]
  autopayStates: GetBrokersRequiredPaymentsAutopayStatesItem[]
}>

export function RequiredPaymentsProvider ({
  automatedCarriers,
  autopayStates,
  children,
}: RequiredPaymentsProviderProps) {
  const [queryParams, setQueryParams] = useState<RequirePaymentsQueryParameters>(
    getRequiredPaymentsDefaultQueryParams()
  )

  return (
    <RequiredPaymentsContext.Provider
      value={{
        automatedCarriers,
        autopayStates,
        queryParams,
        setQueryParams,
      }}
    >
      {children}
    </RequiredPaymentsContext.Provider>
  )
}
